var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,25C50,11.192976,38.8070984,0,25,0C11.1928301,0,0,11.192976,0,25c0,13.8071709,11.1928301,25,25,25 C38.8070984,50,50,38.8071709,50,25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.0001564,33.5796585h-0.0000019c-0.631794,0-1.1439629-0.5121689-1.1439629-1.1439629V17.5641861 c0-0.6317921,0.5121689-1.143961,1.1439629-1.143961h0.0000019c0.6317921,0,1.143961,0.5121689,1.143961,1.143961v14.8715096 C26.1441174,33.0674896,25.6319485,33.5796585,25.0001564,33.5796585z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.4359093,26.1439037H17.5643997c-0.631794,0-1.1439629-0.5121689-1.1439629-1.143961v-0.0000019 c0-0.6317921,0.5121689-1.143961,1.1439629-1.143961h14.8715096c0.631794,0,1.1439629,0.5121689,1.1439629,1.143961v0.0000019 C33.5798721,25.6317348,33.0677032,26.1439037,32.4359093,26.1439037z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.e95c1f85bf70f0015d7eb8d5bf0b1d37.svg";
export { ForwardRef as ReactComponent };